import { render, staticRenderFns } from "./Productgroups.vue?vue&type=template&id=375d56a5&"
import script from "./Productgroups.vue?vue&type=script&lang=js&"
export * from "./Productgroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports